/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerRefineMutationResponse } from "../../models/incidentAgentController/IncidentInvestigationControllerRefine";

function getIncidentInvestigationControllerRefineUrl() {
  const res = { method: 'POST', url: `/api/v1/incident-agent/investigations/refine` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/refine}
 */
export async function incidentInvestigationControllerRefine(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerRefineMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getIncidentInvestigationControllerRefineUrl().url.toString(), ... requestConfig })  
  return res.data
}